import { TeachingLoadReportType } from '@bp/planung-graphql-types';
import { Card, Grid, GridColumn, GridRow } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { TeachingLoadReportsTable } from '../../../../../components/Deputate/Tables/TeachingLoadReportsTable';
import {
  TeachingLoadReportTypesTable,
  TeachingLoadReportTypesTableType,
} from '../../../../../components/Deputate/Tables/TeachingLoadReportTypesTable';

export const DeputateEvaluateCurrentReportsSubpage = () => {
  const { t } = useTranslation();

  const [headline, setHeadline] = useState<string>(t('pdf.currentDetails'));
  const [subType, setSubType] = useState<TeachingLoadReportType>(TeachingLoadReportType.CurrentSingleTeacher);

  const { blockUuid } = useParams();
  const timetableBlockUuid = blockUuid === t('routes.deputate.evaluate.all.slug') ? 'all' : (blockUuid ?? 'all');

  const tableData: TeachingLoadReportTypesTableType[] = [
    { type: TeachingLoadReportType.CurrentSingleTeacher, name: t('pdf.currentDetails') },
    { type: TeachingLoadReportType.CurrentOverview, name: t('pdf.currentOverview') },
    { type: TeachingLoadReportType.CurrentSubjectGroup, name: t('pdf.currentSubjectGroups') },
    { type: TeachingLoadReportType.CurrentKeyFigures, name: t('pdf.currentKeyFigures') },
    { type: TeachingLoadReportType.CurrentExcel, name: t('pdf.excelExport') },
    { type: TeachingLoadReportType.CurrentLeliste, name: t('pdf.lelisteExport') },
    { type: TeachingLoadReportType.CurrentExcelBerlin, name: t('pdf.berlinExcelExport') },
  ];

  function handleSelect(subType: TeachingLoadReportType, headline: string) {
    setHeadline(headline);
    setSubType(subType);
  }

  return (
    <Grid>
      <GridRow mobileGap={'32px'}>
        <GridColumn width={6}>
          <Card header={{ headline: t('timetable.title', { count: 2 }) }} contentPadding='none'>
            <TeachingLoadReportTypesTable data={tableData} onSelect={handleSelect} />
          </Card>
        </GridColumn>
        <GridColumn width={6}>
          <Card
            header={{
              headline,
            }}
            contentPadding='none'
          >
            <TeachingLoadReportsTable
              showEmptyState={false}
              subType={subType}
              timetableBlockUuid={timetableBlockUuid}
            />
          </Card>
        </GridColumn>
      </GridRow>
    </Grid>
  );
};
